"use client";

import { useAuth } from "@workos-inc/authkit-nextjs/components";
import { NavbarActions, accountDisplayName } from "./navbar-actions";

export function NavbarShell() {
  const { user, signOut } = useAuth();
  return (
    <NavbarActions
      user={
        user
          ? { displayName: accountDisplayName(user), pictureUrl: user.profilePictureUrl }
          : null
      }
      onSignOut={() => void signOut({ returnTo: "/" })}
    />
  );
}
